import React, { createContext, useContext, useState, useCallback } from "react";
import { useAuth } from "../auth/AuthContext";
import CaseDetail from "../views/case-detail";
import AbogadoCaseDetail from "../views/abogado/AbogadoCaseDetail";
import CommandPalette from "./CommandPalette";

// Provides a single global slide-in launcher so notifications, dashboard
// activity rows, etc., can open a case from anywhere in the app.

const Ctx = createContext(null);

export function CaseLauncherProvider({ children }) {
  const { user } = useAuth();
  const [caseId, setCaseId] = useState(null);
  const [defaultTab, setDefaultTab] = useState("general");
  const [tick, setTick] = useState(0);

  const open  = useCallback((id, opts = {}) => {
    setCaseId(id);
    setDefaultTab(opts.tab || "general");
  }, []);
  const close = useCallback(() => setCaseId(null), []);
  const refresh = useCallback(() => setTick(t => t + 1), []);

  // feature/single-role-audit — FALSE POSITIVE: legitimate single-role
  // check on user.role (PRIMARY role). View dispatch by primary role
  // is intentional — multi-role users (e.g. abogado+carpetas) keep
  // their primary view. Per-feature multi-role gates inside the views
  // (P2.1 carpeta upload, P2.2 status badge) handle cross-role access.
  const Panel = user?.role === "abogado" ? AbogadoCaseDetail : CaseDetail;

  return (
    <Ctx.Provider value={{ open, close }}>
      {children}
      <Panel
        key={tick}
        caseId={caseId}
        open={caseId != null}
        defaultTab={defaultTab}
        onClose={close}
        onChanged={refresh}
      />
      <CommandPalette />
    </Ctx.Provider>
  );
}

export function useCaseLauncher() {
  return useContext(Ctx) || { open: () => {}, close: () => {} };
}
